import { Navigate, Route, Routes } from "react-router-dom";

import About from "./pages/About";
import Blog from "./pages/Blog";
import BookConsultation from "./pages/BookConsultation";
import BuyAHome from "./pages/BuyAHome";
import CarpentryPage from "./pages/CarpentryPage";
import CleaningPage from "./pages/CleaningPage";
import CommunityImpact from "./pages/CommunityImpact";
import DominicanRepublicInvesting from "./pages/DominicanRepublicInvesting";
import DRListingDetail from "./pages/DRListingDetail";
import DRListings from "./pages/DRListings";
import Events from "./pages/Events";
import EventDetail from "./pages/EventDetail";
import FAQ from "./pages/FAQ";
import Index from "./pages/Index";
import InteriorDesign from "./pages/InteriorDesign";
import InvestInRealEstate from "./pages/InvestInRealEstate";
import ListingDetail from "./pages/ListingDetail";
import Listings from "./pages/Listings";
import NotFound from "./pages/NotFound";
import PaintingPage from "./pages/PaintingPage";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import PropertyPreparationLanding from "./pages/PropertyPreparationLanding";
import ResourcesLanding from "./pages/ResourcesLanding";
import Guides from "./pages/Guides";
import SellYourHome from "./pages/SellYourHome";
import Sitemap from "./pages/Sitemap";
import StyleGuide from "./pages/StyleGuide";
import SuccessStories from "./pages/SuccessStories";
import TeamEsther from "./pages/TeamEsther";
import TeamJessiree from "./pages/TeamJessiree";
import Team from "./pages/Team";
import TermsOfService from "./pages/TermsOfService";
import WorkWithUs from "./pages/WorkWithUs";
import Unsubscribe from "./pages/Unsubscribe";
import AdminLogin from "./pages/admin/AdminLogin";
import AdminForgotPassword from "./pages/admin/AdminForgotPassword";
import AdminResetPassword from "./pages/admin/AdminResetPassword";
import AdminDashboard from "./pages/admin/AdminDashboard";
import AdminSubmissions from "./pages/admin/AdminSubmissions";
import AdminAnnouncements from "./pages/admin/AdminAnnouncements";
import AdminEvents from "./pages/admin/AdminEvents";
import AdminMedia from "./pages/admin/AdminMedia";
import AdminTestimonials from "./pages/admin/AdminTestimonials";
import AdminTeam from "./pages/admin/AdminTeam";
import AdminProperties from "./pages/admin/AdminProperties";
import AdminPages from "./pages/admin/AdminPages";
import AdminSettings from "./pages/admin/AdminSettings";

const AppRoutes = () => (
  <Routes>
    <Route path="/" element={<Index />} />
    <Route path="/about" element={<About />} />
    <Route path="/work-with-us" element={<WorkWithUs />} />
    <Route path="/events" element={<Events />} />
    <Route path="/events/:slug" element={<EventDetail />} />
    <Route path="/buy-a-home" element={<BuyAHome />} />
    <Route path="/sell-your-home" element={<SellYourHome />} />
    <Route path="/invest" element={<InvestInRealEstate />} />

    <Route path="/interior-design" element={<InteriorDesign />} />
    <Route path="/work-with-us/interior-design" element={<Navigate to="/interior-design" replace />} />

    <Route path="/listings" element={<Listings />} />

    <Route path="/dominican-republic" element={<DominicanRepublicInvesting />} />
    <Route path="/dominican-republic-investing" element={<Navigate to="/dominican-republic" replace />} />
    <Route path="/dominican-republic-investing/properties" element={<DRListings />} />
    <Route path="/dominican-republic-investing/properties/:slug" element={<DRListingDetail />} />

    <Route path="/community-impact" element={<CommunityImpact />} />
    <Route path="/team" element={<Team />} />
    <Route path="/team/esther-summersett" element={<TeamEsther />} />
    <Route path="/team/jessiree-pena" element={<TeamJessiree />} />

    <Route path="/property-preparation" element={<PropertyPreparationLanding />} />
    <Route path="/property-preparation/cleaning" element={<Navigate to="/cleaning" replace />} />
    <Route path="/property-preparation/carpentry" element={<Navigate to="/carpentry" replace />} />
    <Route path="/property-preparation/painting" element={<Navigate to="/painting" replace />} />
    <Route path="/cleaning" element={<CleaningPage />} />
    <Route path="/carpentry" element={<CarpentryPage />} />
    <Route path="/painting" element={<PaintingPage />} />
    <Route path="/consultation" element={<BookConsultation />} />
    <Route path="/book-consultation" element={<Navigate to="/consultation" replace />} />

    <Route path="/resources" element={<ResourcesLanding />} />
    <Route path="/resources/guides" element={<Guides />} />
    <Route path="/blog" element={<Blog />} />
    <Route path="/resources/blog" element={<Navigate to="/blog" replace />} />

    <Route path="/success-stories" element={<SuccessStories />} />
    <Route path="/faq" element={<FAQ />} />
    <Route path="/privacy-policy" element={<PrivacyPolicy />} />
    <Route path="/terms-of-service" element={<TermsOfService />} />
    <Route path="/style-guide" element={<StyleGuide />} />
    <Route path="/sitemap" element={<Sitemap />} />
    <Route path="/listing/:slug" element={<ListingDetail />} />
    <Route path="/unsubscribe" element={<Unsubscribe />} />

    {/* Admin */}
    <Route path="/admin/login" element={<AdminLogin />} />
    <Route path="/admin/forgot-password" element={<AdminForgotPassword />} />
    <Route path="/admin/reset-password" element={<AdminResetPassword />} />
    <Route path="/admin" element={<AdminDashboard />} />
    <Route path="/admin/submissions" element={<AdminSubmissions />} />
    <Route path="/admin/announcements" element={<AdminAnnouncements />} />
    <Route path="/admin/events" element={<AdminEvents />} />
    <Route path="/admin/testimonials" element={<AdminTestimonials />} />
    <Route path="/admin/media" element={<AdminMedia />} />
    <Route path="/admin/team" element={<AdminTeam />} />
    <Route path="/admin/properties" element={<AdminProperties />} />
    <Route path="/admin/pages" element={<AdminPages />} />
    <Route path="/admin/settings" element={<AdminSettings />} />

    <Route path="*" element={<NotFound />} />
  </Routes>
);

export default AppRoutes;
